import { httpClient } from "./httpClient";
import { getToken, getUserName, getUserId } from "../Common/utils/auth";
import { BASE_URL } from "../Common/constant";
import axios from "axios";

export const findCustomer = async (searchParams: any) => {
    try {
        for (const key in searchParams) {
            if (searchParams[key]) {
                const result = await httpClient("customer/find", "POST", {
                    findkey: key,
                    [key]: searchParams[key],
                });
                return result.data;
            }
        }
        return null;
    } catch (error) {
        console.error("Error finding customer:", error);
        throw error;
    }
};

export const updateCustomer = async (customerData: any) => {
    try {
        const result = await axios.post(BASE_URL + "customer/update", {
            ...customerData,
            updatedBy: getUserName()
        },
            {
                headers: {
                    encryption: false,
                    token: getToken()
                },
            });
        return result.data;
    } catch (error) {
        console.error("Error updating customer:", error);
        throw error;
    }
};

export const deleteCustomer = async (customerId: string) => {
    try {
        const result = await axios.post(BASE_URL + "customer/delete", { customerId }, {
            headers: {
                encryption: false,
                token: getToken()
            }
        });
        return result.data;
    } catch (error) {
        console.error("Error deleting customer:", error);
        throw error;
    }
};

export const fetchUser = async () => {
    try {
        const result = await axios.post(BASE_URL + "user/find",
            {
                "user_id": getUserId()
            },
            {
                headers: {
                    encryption: false,
                    token: getToken()
                }
            });
        return result.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getAllAgents = async () => {
    try {
        const result = await axios.get(BASE_URL + "agent/getall/active", {
            headers: {
                encryption: false,
                token: getToken()
            },
        });
        return result.data.data.agents;
    } catch (error) {
        console.error("Error fetching all agents:", error);
        throw error;
    }
};